import { combineReducers } from "redux";
import session from "./session/reducer";
import portal from "./portal/reducer";

const rootReducer = combineReducers({
  session,
  portal,
});

export default rootReducer;
